import { SNETDialog } from "shared/dist/components";
import HostingUnavailableBackground from "../../Assets/hosting-unavailable-background.png";
import { navigate } from "../../../../Utils/";
import "./style.css";
import PropTypes from "prop-types";
import { Button } from "@mui/material";

const HostingUnavailable = ({ onClose }) => {
    return (
        <SNETDialog
            isDialogOpen={true}
            isHeaderHidden={true}
            showCloseButton={false}
            onDialogClose={onClose}
            maxWidth={false}
            contentClass="hosting-unavailable"
            PaperProps={{ sx: { background: "transparent" } }}
        >
            <div
                className="hosting-unavailable-body"
                style={{ background: `url(${HostingUnavailableBackground})` }}
            >
                <div className="hosting-unavailable-header">
                    <button className="hosting-unavailable-close-button" onClick={onClose}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                        >
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M14 1.4L12.6 0L7 5.6L1.4 0L0 1.4L5.6 7L0 12.6L1.4 14L7 8.4L12.6 14L14 12.6L8.4 7L14 1.4Z"
                                fill="white"
                            />
                        </svg>
                    </button>
                </div>
                <div className="hosting-unavailable-title">
                    <h2>HaaS is only available on the Mainnet Publisher</h2>
                </div>
                <p>
                    The Testnet Publisher, running on Sepolia, does not support Hosting-as-a-Service
                    functionality. Please use the Mainnet Publisher to access all HaaS features.
                </p>
                <div className="hosting-unavailable-actions">
                    <div className="hosting-unavailable-action">
                        <div className="hosting-unavailable-action-button">
                            <Button
                                variant="contained"
                                sx={{
                                    textTransform: "unset",
                                    backgroundColor: "#fff",
                                    fontWeight: "600",
                                    color: "var(--color-custom-black)",
                                    "&:hover": {
                                        backgroundColor: "var(--color-accent-dark-grey)",
                                    },
                                }}
                                onClick={() => navigate("https://publisher.singularitynet.io")}
                            >
                                Go to Mainnet Publisher
                            </Button>
                        </div>
                        <p>HaaS is fully available there</p>
                    </div>
                    <div className="hosting-unavailable-action">
                        <div className="hosting-unavailable-action-button">
                            <Button
                                variant="contained"
                                sx={{
                                    textTransform: "unset",
                                    backgroundColor: "#fff",
                                    fontWeight: "600",
                                    color: "var(--color-custom-black)",
                                    "&:hover": {
                                        backgroundColor: "var(--color-accent-dark-grey)",
                                    },
                                }}
                                onClick={() =>
                                    navigate(
                                        "https://dev.singularitynet.io/docs/products/DecentralizedAIPlatform/HaaS/"
                                    )
                                }
                            >
                                HaaS Documentation
                            </Button>
                        </div>
                        <p>Learn more on Developer Portal</p>
                    </div>
                </div>
            </div>
        </SNETDialog>
    );
};

export function isHostingAvailable() {
    const stand = process.env.REACT_APP_STAND;
    const allowedStands = ["prod", "dev"];

    return allowedStands.includes(stand);
}

export default HostingUnavailable;

HostingUnavailable.propTypes = {
    onClose: PropTypes.func,
};
